<template>
  <div class="section">
    <div class="container">
      <div class="content">
	<h1>{{$t('Imprint')}}</h1>
	<Contact/>
      </div>
    </div>
  </div>
</template>

<script>
 import Contact from '@/components/Contact.vue'

 export default {
   components: { Contact }
 }
</script>
